import Quill from 'quill';
import { Mention, MentionBlot } from 'quill-mention';

export function isQuillMentionRegistered(): boolean {
  return Quill.imports['modules/mention'] != null && Quill.imports['blots/mention'] != null;
}

export function ensureQuillMentionRegistered(): void {
  if (isQuillMentionRegistered()) {
    return;
  }
  Quill.register({ 'blots/mention': MentionBlot, 'modules/mention': Mention });
}
